import { useState, useEffect } from 'react'
import { subscribeToArchiveUser, type ArchiveUser } from '../services/firebaseAuth'

interface UseArchiveUserReturn {
  user: ArchiveUser | null
  isResolved: boolean
}

/**
 * Tracks the media-archive session established at /login.html.
 *
 * `isResolved` distinguishes "still loading the auth module" from "signed out", so the UI can stay
 * quiet until the answer is known rather than flashing a signed-out state at every visitor.
 */
export function useArchiveUser(): UseArchiveUserReturn {
  const [user, setUser] = useState<ArchiveUser | null>(null)
  const [isResolved, setIsResolved] = useState(false)

  useEffect(() => {
    const unsubscribe = subscribeToArchiveUser((nextUser) => {
      setUser(nextUser)
      setIsResolved(true)
    })
    return unsubscribe
  }, [])

  return { user, isResolved }
}
